/**
 * Auto Scroll Depth — 스크롤 깊이 추적
 * 25%, 50%, 75%, 100% 도달 시 각각 1회만 발화
 * 라우트 변경 시 리셋
 */

var THRESHOLDS = [25, 50, 75, 100];

export function initScrollDepth(mixpanel, router) {
  var firedThresholds = {};
  var currentPath = "";
  var rafPending = false;

  function resetThresholds(path) {
    try {
      firedThresholds = {};
      currentPath = path;
    } catch (e) {
      // 무시
    }
  }

  function getScrollPercent() {
    try {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var docHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
        document.documentElement.clientHeight,
      );
      var winHeight = window.innerHeight;

      if (docHeight <= winHeight) return 100; // 스크롤 없는 페이지

      var scrollable = docHeight - winHeight;
      if (scrollable <= 0) return 100;

      return Math.round((scrollTop / scrollable) * 100);
    } catch (e) {
      return 0;
    }
  }

  function checkThresholds() {
    try {
      var percent = getScrollPercent();

      THRESHOLDS.forEach(function (threshold) {
        if (percent >= threshold && !firedThresholds[threshold]) {
          firedThresholds[threshold] = true;

          var trackFn = function () {
            try {
              mixpanel.track("Auto Scroll Depth", {
                depth_percent: threshold,
                route_path: currentPath,
              });
            } catch (e) {
              // 무시
            }
          };

          if (typeof requestIdleCallback === "function") {
            requestIdleCallback(trackFn);
          } else {
            setTimeout(trackFn, 0);
          }
        }
      });
    } catch (e) {
      // 무시
    }
  }

  function scrollHandler() {
    try {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        checkThresholds();
      });
    } catch (e) {
      // 무시
    }
  }

  // 초기 경로 설정
  try {
    currentPath = window.location.pathname;
  } catch (e) {
    currentPath = "";
  }

  // 라우트 변경 시 리셋
  if (router && typeof router.afterEach === "function") {
    router.afterEach(function (to) {
      try {
        resetThresholds(to.path);
        // 라우트 변경 직후 스크롤 체크 (SPA 특성상 스크롤 안 할 수 있음)
        setTimeout(function () {
          checkThresholds();
        }, 500);
      } catch (e) {
        // 무시
      }
    });
  }

  window.addEventListener("scroll", scrollHandler, { passive: true, capture: true });

  // 초기 체크 (스크롤 없는 짧은 페이지 대응)
  setTimeout(function () {
    checkThresholds();
  }, 1000);
}
